import { usePermission } from '@backstage/plugin-permission-react';
import { agenticMarketplaceReadPermission } from '@internal/backstage-plugin-agentic-marketplace-common';

/**
 * Resolves the Agentic Marketplace RBAC permission through the permission
 * backend so components don't repeat the `usePermission` wiring by hand.
 */
export const useAgenticMarketplacePermissions = (): {
  canRead: boolean;
  loading: boolean;
  error?: Error;
} => {
  const {
    allowed: canRead,
    loading,
    error,
  } = usePermission({ permission: agenticMarketplaceReadPermission });

  return { canRead, loading, error };
};
